import { getI18nLangLocale } from 'pricing-pages-ui-components/utils/languageUtils';
export default (() => {
  return getI18nLangLocale() || 'en-us';
});